import React from "react";
import {
  extraService, serviceTitle, serviceContainer, checkService,
  servicePrices, servicePriceAtCompare, servicePrice, regularCheckbox,
} from "./style.mod.scss";
import Money from "components/money";

const ReCoatingService = ({
  service,
  setCoatingServiceAdded,
  totalPrice,
  setTotalPrice,
  totalCompareAtPrice,
  setTotalCompareAtPrice,
}) => {

  const addReCoatingService = (checked) => {
    setCoatingServiceAdded(checked ? true : false);
    const price = parseFloat(service.variant.price);

    const priceAtCompare = parseFloat(service.variant.priceAtCompare);
    if (priceAtCompare > 0) {
      setTotalCompareAtPrice(checked ?
        totalCompareAtPrice + priceAtCompare :
        totalCompareAtPrice - priceAtCompare);
    } else {
      setTotalCompareAtPrice(checked ?
        totalCompareAtPrice + price :
        totalCompareAtPrice - price);
    }
    setTotalPrice(checked ? totalPrice + price : totalPrice - price);
  };

  return (
    <div className={extraService}>
      {service?.title && (
        <p className={serviceTitle}>{service.title}</p>
      )}
      <div className={serviceContainer}>
        <div className={checkService}>
          <input onClick={e => addReCoatingService(e.target.checked)}
            className={regularCheckbox}
            type="checkbox" />
          <span> {service?.productTitle ?
            service.productTitle :
            service.variant.title}</span>
        </div>
        <div className={servicePrices}>
          {service.variant.priceAtCompare !== "0" && (
            <span className={servicePriceAtCompare}>
              <Money value={service.variant.priceAtCompare} />
            </span>
          )}
          <span className={servicePrice}>
            <Money value={service.variant.price} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default ReCoatingService;